import { render, staticRenderFns } from "./product-is-featured.vue?vue&type=template&id=50db8ae5"
import script from "./product-is-featured.vue?vue&type=script&lang=ts"
export * from "./product-is-featured.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports